import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { EditComponent } from './edit.component';
import { EditRoutingModule } from './edit.routing.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EditRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    EditComponent
  ],
  declarations: [
    EditComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class EditModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: EditModule,
            providers: [ GenericdatasetService ]
        };
    }
}
